var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTonkeeper56(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105 35.625 60 49.5V105l45-69.375Z",
    fill: "#47A9F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 35.625 60 49.5V105L15 35.625Z",
    fill: "#75C1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 35.625 60 15l45 20.625L60 56.25 15 35.625Z",
    fill: "#8DCCFC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTonkeeper56);
export default __webpack_public_path__ + "static/media/tonkeeper_56.a0a4e1f1.svg";
export { ForwardRef as ReactComponent };